import { window } from 'browser-monads';
import AbstractAnalytics from './abstract-analytics';
import { EventArgs, EventValues } from './analytics';

export class GoogleAnalytics extends AbstractAnalytics {

	public getEventName(): string {
		return EventValues.GAEvent;
	}

	public push(eventArgs: EventArgs): void {
		if (window.dataLayer) {
			window.dataLayer?.push(eventArgs);
		} else {
			console.error('dataLayer not initialized');
		}
	}
}
